import { jsx as _jsx } from "react/jsx-runtime";
// src/plugins/sdk/PluginContext.tsx
// Every plugin renders inside <PluginHost pluginId=... />, which provides this context.
// All SDK hooks read `usePluginId()` and enforce the plugin's declared permissions.
import { createContext, useContext } from 'react';
const PluginCtx = createContext(null);
export function PluginContextProvider({ pluginId, children }) {
    return _jsx(PluginCtx.Provider, { value: { pluginId }, children: children });
}
export function usePluginId() {
    const ctx = useContext(PluginCtx);
    if (!ctx)
        throw new Error('Plugin SDK used outside a PluginContextProvider. Wrap your plugin with <PluginHost />.');
    return ctx.pluginId;
}
